
// import React, { useEffect, useState } from "react";
// import { Icon } from "@iconify/react";
// import Swal from "sweetalert2";
// import "../warehousedetails/wareHouseDetails.scss";
// import { fetchData } from "../helper/api.interceptor";
// import indiaLocations from "../data/indiaLocations.json";

// const EditWarehouseDetails = ({ show, onClose, warehouseId, onWarehouseUpdated }) => {
//     const [form, setForm] = useState({
//         warehouse_name: "",
//         warehouse_id: "",
//         state: "",
//         district: "",
//         city: "",
//         pincode: "",
//     });

//     const [districts, setDistricts] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // Fetch warehouse details for editing
//     useEffect(() => {
//         const fetchWarehouse = async () => {
//             if (!warehouseId || !show) return;
//             setLoading(true);
//             try {
//                 const res = await fetchData.get(`/get-by-id/${warehouseId}`);
//                 if (res?.result) {
//                     setForm({
//                         warehouse_name: res.result.warehouse_name || "",
//                         warehouse_id: res.result.warehouse_id || "",
//                         state: res.result.state || "",
//                         district: res.result.district || "",
//                         city: res.result.city || "",
//                         pincode: res.result.pincode || "",
//                     });
//                 }
//             } catch (error) {
//                 Swal.fire("Error", "Failed to load warehouse details", "error");
//             }
//             setLoading(false);
//         };
//         fetchWarehouse();
//     }, [warehouseId, show]);

//     // Update districts when state changes
//     useEffect(() => {
//         if (!form.state) {
//             setDistricts([]);
//             setCities([]);
//             return;
//         }

//         const stateObj = indiaLocations.find((s) => s.state === form.state);
//         setDistricts(stateObj?.districts || []);

//         // Don't reset district/city on initial load
//     }, [form.state]);

//     useEffect(() => {
//         if (!districts.length) return; // wait for districts to be populated

//         const districtObj = districts.find((d) => d.district === form.district);
//         if (districtObj?.subDistricts) {
//             const allVillages = districtObj.subDistricts.flatMap(sd => sd.villages || []);
//             setCities(allVillages);

//             // Only reset city if it's not in allVillages AND user changed district
//             // Skip reset on first load
//             if (form.city && !allVillages.includes(form.city)) {
//                 setForm(prev => ({ ...prev, city: "" }));
//             }
//         } else {
//             setCities([]);
//             // Don't reset city on first load
//         }
//     }, [form.district, districts]);
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const { warehouse_name, state, district, city, pincode } = form;

//         if (!warehouse_name || !state || !district || !city || !pincode) {
//             return Swal.fire("Missing Fields", "Please fill out all fields", "warning");
//         }

//         setLoading(true);
//         try {
//             // Create a FormData instance
//             const formData = new FormData();
//             formData.append("warehouse_name", warehouse_name);
//             formData.append("state", state);
//             formData.append("district", district);
//             formData.append("city", city);
//             formData.append("pincode", pincode);

//             // If you want to debug:
//             for (const [key, value] of formData.entries()) {
//                 console.log(key, value);
//             }

//             const res = await fetchData.postWithFormData(
//                 `/update-warehouse?warehouse_id=${form.warehouse_id}`,
//                 formData
//             );

//             if (res?.status_code === 200) {
//                 Swal.fire("Success", "Warehouse updated successfully", "success");
//                 onWarehouseUpdated();
//                 onClose();
//             } else {
//                 throw new Error(res?.message || "Failed to update warehouse");
//             }
//         } catch (error) {
//             Swal.fire("Error", error.message, "error");
//         } finally {
//             setLoading(false);
//         }
//     };
//     if (!show) return null;

//     return (
//         <div className="modal-backdrop">
//             <div className="modal-container">
//                 <form className="modal-content" onSubmit={handleSubmit}>
//                     <div className="modal-header">
//                         <h5 className="modal-title">Edit Warehouse Details</h5>
//                         <button type="button" className="close-btn" onClick={onClose}>
//                             <Icon icon="mdi:close" />
//                         </button>
//                     </div>
//                     <div className="modal-body">
//                         <div className="form-group">
//                             <label>Warehouse Name</label>
//                             <input
//                                 type="text"
//                                 name="warehouse_name"
//                                 value={form.warehouse_name}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 required
//                             />
//                         </div>

//                         <div className="form-group">
//                             <label>Warehouse ID</label>
//                             <input
//                                 type="text"
//                                 name="warehouse_id"
//                                 value={form.warehouse_id}
//                                 className="form-control"
//                                 readOnly
//                             />
//                         </div>

//                         <div className="form-group">
//                             <label>State</label>
//                             <select
//                                 name="state"
//                                 value={form.state}
//                                 onChange={handleChange}
//                                 className="form-control"
//                             >
//                                 <option value="">Select State</option>
//                                 {indiaLocations.map((s) => (
//                                     <option key={s.state} value={s.state}>
//                                         {s.state}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="form-group">
//                             <label>District</label>
//                             <select
//                                 name="district"
//                                 value={form.district}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 disabled={!districts.length}
//                             >
//                                 <option value="">Select District</option>
//                                 {districts.map((d) => (
//                                     <option key={d.district} value={d.district}>
//                                         {d.district}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="form-group">
//                             <label>City / Village</label>
//                             <select
//                                 name="city"
//                                 value={form.city}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 disabled={!cities.length}
//                             >
//                                 <option value="">Select City</option>
//                                 {cities.map((c) => (
//                                     <option key={c} value={c}>
//                                         {c}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="form-group">
//                             <label>Pincode</label>
//                             <input
//                                 type="text"
//                                 name="pincode"
//                                 value={form.pincode}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 required
//                             />
//                         </div>
//                     </div>
//                     <div className="modal-footer">
//                         <button type="button" className="btn btn-secondary" onClick={onClose}>
//                             Cancel
//                         </button>
//                         <button type="submit" className="btn btn-primary" disabled={loading}>
//                             {loading ? (
//                                 <>
//                                     <Icon icon="eos-icons:loading" className="spinner" />
//                                     Updating...
//                                 </>
//                             ) : (
//                                 "Update Warehouse"
//                             )}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default EditWarehouseDetails;
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import "../warehousedetails/wareHouseDetails.scss";
import { fetchData } from "../helper/api.interceptor";
import Select from "react-select";
import indiaLocations from "../data/indiaLocations.json";

const EditWarehouseDetails = ({ show, onClose, warehouseId, onWarehouseUpdated }) => {
    const [form, setForm] = useState({
        warehouse_name: "",
        warehouse_id: "",
        state: "",
        cities: [],
        pincode: "",
    });

    const [availableCities, setAvailableCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasLoadedInitialData, setHasLoadedInitialData] = useState(false);

    // Fetch warehouse details for editing
    useEffect(() => {
        const fetchWarehouse = async () => {
            if (!warehouseId || !show) return;
            setLoading(true);
            try {
                const res = await fetchData.get(`/get-by-id/${warehouseId}`);
                if (res?.result) {
                    const warehouseData = res.result;

                    console.log("API Response:", warehouseData); // Debug log

                    // Convert existing cities to multi-select format
                    const existingCities = warehouseData.cities || [];
                    const citiesArray = Array.isArray(existingCities)
                        ? existingCities.map(city => ({ label: city, value: city }))
                        : [];

                    console.log("Converted cities:", citiesArray); // Debug log

                    setForm({
                        warehouse_name: warehouseData.warehouse_name || "",
                        warehouse_id: warehouseData.warehouse_id || "",
                        state: warehouseData.state || "",
                        cities: citiesArray,
                        pincode: warehouseData.pincode || "",
                    });

                    // Load available cities for the state
                    if (warehouseData.state) {
                        const stateObj = indiaLocations.find((s) => s.state === warehouseData.state);
                        const districtList = stateObj?.districts?.map(d => d.district) || [];
                        setAvailableCities(districtList);
                        console.log("Available cities loaded:", districtList); // Debug log
                    }

                    setHasLoadedInitialData(true);
                }
            } catch (error) {
                console.error("Error fetching warehouse:", error);
                Swal.fire("Error", "Failed to load warehouse details", "error");
            }
            setLoading(false);
        };
        fetchWarehouse();
    }, [warehouseId, show]);

    // Update available cities when state changes - BUT don't reset cities on initial load
    useEffect(() => {
        if (form.state && hasLoadedInitialData) {
            const stateObj = indiaLocations.find((s) => s.state === form.state);
            const districtList = stateObj?.districts?.map(d => d.district) || [];
            setAvailableCities(districtList);

            // Only reset cities if user manually changes state after initial load
            // Don't reset during initial data population
            if (!hasLoadedInitialData) {
                setForm((prev) => ({ ...prev, cities: [] }));
            }
        } else {
            setAvailableCities([]);
        }
    }, [form.state, hasLoadedInitialData]);

    // Separate useEffect to handle manual state changes
    useEffect(() => {
        if (hasLoadedInitialData && form.state) {
            // This will only run after initial data is loaded and state changes
            const stateObj = indiaLocations.find((s) => s.state === form.state);
            const districtList = stateObj?.districts?.map(d => d.district) || [];
            setAvailableCities(districtList);
        }
    }, [form.state, hasLoadedInitialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleStateChange = (selected) => {
        // When user manually changes state, reset cities
        setForm((prev) => ({
            ...prev,
            state: selected?.value || "",
            cities: [] // Reset cities only on manual state change
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { warehouse_name, state, cities, pincode } = form;

        if (!warehouse_name || !state || !cities.length || !pincode) {
            return Swal.fire("Missing Fields", "Please fill out all fields", "warning");
        }

        setLoading(true);
        try {
            const payload = new FormData();
            payload.append("warehouse_name", warehouse_name);
            payload.append("state", state);
            payload.append("pincode", pincode);

            // Append cities properly
            cities.forEach((city) => payload.append("cities[]", city.value));

            console.log("Updating warehouse with:", {
                warehouse_name,
                state,
                cities: cities.map(c => c.value),
                pincode
            });

            const res = await fetchData.postWithFormData(
                `/update-warehouse?warehouse_id=${form.warehouse_id}`,
                payload
            );

            if (res?.status_code === 200) {
                Swal.fire("Success", "Warehouse updated successfully", "success");
                onWarehouseUpdated();
                onClose();
            } else {
                throw new Error(res?.message || "Failed to update warehouse");
            }
        } catch (error) {
            Swal.fire("Error", error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-container">
                <form className="modal-content" onSubmit={handleSubmit}>
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Warehouse Details</h5>
                        <button type="button" className="close-btn" onClick={onClose}>
                            <Icon icon="mdi:close" />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Warehouse Name *</label>
                            <input
                                type="text"
                                name="warehouse_name"
                                value={form.warehouse_name}
                                onChange={handleChange}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Warehouse ID</label>
                            <input
                                type="text"
                                name="warehouse_id"
                                value={form.warehouse_id}
                                className="form-control"
                                readOnly
                            />
                        </div>

                        <div className="form-group">
                            <label>State *</label>
                            <Select
                                options={indiaLocations.map((s) => ({
                                    label: s.state,
                                    value: s.state,
                                }))}
                                value={form.state ? { label: form.state, value: form.state } : null}
                                onChange={handleStateChange}
                                placeholder="Search & Select State"
                                isClearable
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Cities *</label>
                            <Select
                                isMulti
                                options={availableCities.map((city) => ({
                                    label: city,
                                    value: city,
                                }))}
                                value={form.cities}
                                onChange={(selected) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        cities: selected || [],
                                    }))
                                }
                                placeholder={
                                    form.state ? "Select one or more cities" : "Please select state first"
                                }
                                isDisabled={!availableCities.length}
                                required
                            />
                        </div>

                        {/* <div className="form-group">
                            <label>Pincode *</label>
                            <input
                                type="text"
                                name="pincode"
                                value={form.pincode}
                                onChange={handleChange}
                                className="form-control"
                                required
                            />
                        </div> */}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? (
                                <>
                                    <Icon icon="eos-icons:loading" className="spinner" />
                                    Updating...
                                </>
                            ) : (
                                "Update Warehouse"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditWarehouseDetails;